export const products = {
      title: 'Productos',
      subtitle: 'Administra el catálogo simple de productos.',
      recordsTitle: 'Registros de productos',
      recordsDescription: 'Catálogo para administrar productos sin costo ni datos demo.',
      createTitle: 'Agregar producto',
      editTitle: 'Editar producto',
      createSubtitle: 'Captura los datos principales del producto.',
      editSubtitle: 'Actualiza los datos principales del producto.',
      isActiveLabel: 'Producto activo',
      isActiveHint: 'Desactiva el producto si ya no debe aparecer como opción operativa.',
      packagingTypesLabel: 'Tipos de empaque',
      defaultPackagingTypeOption: 'Marcar como predeterminado',
      packagingTypesEmpty: 'No hay tipos de empaque disponibles.',
      deleteTitle: 'Eliminar producto',
      deleteSubtitle: 'Esta acción eliminará el producto {{name}}.',
      deleteSubtitleFallback: 'Esta acción eliminará el producto seleccionado.',
      emptyTitle: 'Sin productos disponibles',
      emptyDescription: 'No hay productos registrados todavía.',
    } as const;
